module.exports = __webpack_public_path__ + "images/img-5.c98efb58.jpg";